export default class CompanyData {
    constructor(id, name, computationTokens, remainingTokens) {
        this.id = id
        this.name = name
        this.computationTokens = computationTokens
        this.remainingTokens = remainingTokens
    }
}